import React, { useContext } from 'react';
import Modal from 'react-modal';
import { XMarkIcon } from '@heroicons/react/24/solid';
import UserContext from '../../contexts/UserContext';
import Button from '../Button';

interface ExtraServicesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ExtraServicesModal: React.FC<ExtraServicesModalProps> = ({ isOpen, onClose }) => {
  const { user } = useContext(UserContext);
  const handleContactSupport = () => {
    window.location.href = 'mailto:info@kitkeeper.co.uk?subject=Extra Services Request';
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal-content extra-services-modal"
      overlayClassName="modal-overlay"
      ariaHideApp={false}
    >
      <div className="modal-header">
        <h2>Extra Services</h2>
        <Button
          variant="tertiary"
          size="sm"
          iconOnly
          className="modal-close-btn"
          aria-label="Close"
          onClick={onClose}
        >
          <XMarkIcon aria-hidden="true" />
        </Button>
      </div>
      
      <div className="modal-body">
        <p className="extra-services-intro">
          Howdy there {user?.firstName}! 👋
        </p>

        <div className="extra-services-list">
          <div className="extra-service-item">
            <h3>Weights and Dimensions - £15 per box</h3>
          </div>

          <div className="extra-service-item">
            <h3>Disposal - £10 per box</h3>
          </div>

          <div className="extra-service-item">
            <h3>Picture of contents - £15 per box</h3>
          </div>

          <div className="extra-service-item">
            <h3>Repack - £30 per box</h3>
          </div>

          <div className="extra-service-item">
            <h3>Time slot - £35 (subject to location availability)</h3>
          </div>

          <div className="extra-service-item">
            <h3>Doorstep - £65 (subject to location availability)</h3>
          </div>
        </div>

        <Button
          variant="primary"
          className="submit-btn extra-services-contact-btn"
          onClick={handleContactSupport}
        >
          Book extra service
        </Button>
      </div>
    </Modal>
  );
};

